/* globals document, window */
import React from "react";
import { hydrate } from "react-dom";
import Signup from "./Signup";

/* Render Signup app into the pug template, pulling props from global window */
function render(props) {
  hydrate(<Signup {...props} />, document.getElementById("react"));
}
render(window.reactProps);
